import styled, { keyframes } from "styled-components";

interface ContainerProps {
    margin: string;
}
const Container = styled.section`
    display: flex;
    justify-content: center;
    margin: ${(p: ContainerProps) => p.margin};
    text-align: center;
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

interface CircularLoaderProps {
    margin: string;
    border: string;
    width: string;
    height: string;
}
export const CircularLoader = styled.div`
    display: block;
    margin: ${(p: CircularLoaderProps) => p.margin};
    border: ${(p: CircularLoaderProps) => p.border} solid #ccc;
    border-top: ${(p: CircularLoaderProps) => p.border} solid #000;
    border-radius: 50%;
    width: ${(p: CircularLoaderProps) => p.width};
    height: ${(p: CircularLoaderProps) => p.height};
    animation: ${spin} 2s linear infinite;
`;

export function Progress({ margin = "80px auto 0" }: { margin?: string }) {
    return (
        <Container margin={margin}>
            <CircularLoader
                margin="0"
                border="4px"
                width="80px"
                height="80px"
            />
        </Container>
    );
}
